import { useCallback, useMemo } from 'react';

import { useFormattingLocales } from '../../utils/getFormattingLocales';

import { PeriodPicker, SharedPeriodPickerProps } from './PeriodPicker';
import {
  formatMonth,
  getMonthNames,
  parseMonth,
  PeriodValue,
} from './periodRange';

export type MonthPickerProps = SharedPeriodPickerProps & {
  /** Locale override for month names and typed month parsing. Defaults to i18n app language. */
  locales?: string | string[];
};

export function MonthPicker({
  locales: providedLocales,
  ...props
}: MonthPickerProps) {
  const locales = useFormattingLocales(providedLocales);
  const format = useCallback(
    (value: PeriodValue) => formatMonth(value, locales),
    [locales]
  );
  const parse = useCallback(
    (input: string) => parseMonth(input, locales),
    [locales]
  );
  const monthLabels = useMemo(() => getMonthNames(locales, 'short'), [locales]);

  return (
    <PeriodPicker
      {...props}
      type="month"
      periodsPerYear={12}
      gridColumns={6}
      format={format}
      parse={parse}
      formatGridPeriod={(month) => monthLabels[month - 1]}
    />
  );
}
